import { Tab, Tabs } from '@mui/material'

interface HeaderModuleTabsProps {
  onChange: (tab: number) => void
  current: number
  options: string[]
  moduleName: string
  disableOptions?: number[]
}

const HeaderModuleTabs = ({ onChange, current, options, moduleName, disableOptions = [] }: HeaderModuleTabsProps) => (
  <Tabs
    value={current}
    onChange={(_event, newValue) => onChange(newValue)}
    aria-label={`${moduleName} tabs`}
  >
    {options.map((tab, index) => (
      <Tab
        label={tab}
        key={index}
        id={`${moduleName}-tab-${index}`}
        aria-controls={`${moduleName}-tabpanel-${index}`}
        disabled={disableOptions.includes(index)}
      />
    ))}
  </Tabs>
)

export default HeaderModuleTabs
